import { ArrowForward, VisibilityOff } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useMemo } from 'react';
import { Section } from '../../../apiTypes';
import DataTable, { Column } from '../../../components/DataTable';
import Image from '../../../components/Image';
import { t } from '../../../constants/translations';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';

type Row = DbDocument<Section>;

type Props = {
  selectSection: (sectionId: string) => void;
  isList: boolean;
};

const SectionsList = ({ selectSection, isList }: Props) => {
  const { lang } = useLocale();
  const { sections } = useCafe();

  const columns: Column<Row>[] = useMemo(
    () => [
      {
        name: 'imageURL',
        title: '',
        render: (r: Row) => <Image src={r.imageUrl} width={120} />,
        sx: { width: 120, pr: 0 },
      },
      {
        name: 'name',
        title: t.name[lang],
        align: 'left',
        render: (r: Row) => (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant={isList ? 'body1' : 'caption'}
              sx={{ color: (t) => (r.show ? t.palette.text.primary : t.palette.text.disabled) }}
            >
              {r.name}
            </Typography>
            {r.show ? '' : <VisibilityOff fontSize="small" color="disabled" sx={{ ml: 1 }} />}
          </Box>
        ),
      },
      {
        name: 'goTo',
        title: '',
        render: isList
          ? (r: Row) => (
              <IconButton>
                <ArrowForward />
              </IconButton>
            )
          : undefined,
      },
    ],
    [lang, isList]
  );

  return (
    <DataTable
      columns={columns}
      rows={sections}
      onRowClick={(row) => selectSection(row.id)}
      isCard={false}
      showHeader={false}
      isGrid={!isList}
      dataTestIdPrefix="section"
    />
  );
};

export default SectionsList;
